import React from "react";
import sanitizeUrl from "../../utils/sanitizeUrl";

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';

import { FreeMode, Pagination } from 'swiper/modules';

const HomeCategories = ({categories}) => {

    const groupedCategories: Array<typeof categories[0]> = [];
    for (let i = 0; i < categories.length; i += 2) {
        groupedCategories.push(categories.slice(i, i + 2));
    }

    return (
        <div className="container">
            <div className="text-md-center mb-md-5 mb-4">
                <h2>Categorías únicas</h2>
            </div>
            <div className="categories-home d-md-flex d-none">
                {categories.length > 0 ? (
                    categories.map((category, key) => (
                        <div
                        onClick={() => window.location.href = `/tienda/${sanitizeUrl(category.name)}?uid=${category.uid}&categoryName=${category.name}`}
                        key={"category-" + key} 
                        className="card-categories">
                            <div className="card-categories__header">
                                <img src={category?.image ? process.env.REACT_APP_API_BASE_URL + '/uploads/categories/' + category.image:""} alt="category" />
                            </div>
                            <div className="card-categories__title">
                                <h3>{category.name}</h3>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No categories available</p>
                )}
            </div>
            <div id="swipper-categories" className="categories-home d-md-none d-block">
                <Swiper
                    slidesPerView={"auto"}
                    spaceBetween={30}
                    freeMode={true}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[
                        FreeMode, 
                        Pagination
                    ]}
                    className="mySwiper"
                >
                    {groupedCategories.length <= 1 ? (
                        categories.map((category, key) => (
                            <SwiperSlide>
                                <div key={`category-${key}`}
                                    onClick={() => window.location.href = `/tienda/${sanitizeUrl(category.name)}?uid=${category.uid}&categoryName=${category.name}`}
                                    className="card-categories">
                                    <div className="card-categories__header">
                                        <img src={category?.image ? process.env.REACT_APP_API_BASE_URL + '/uploads/categories/' + category.image : ""} alt="category" />
                                    </div>
                                    <div className="card-categories__title">
                                        <h3>{category.name}</h3>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))
                    ) : (
                        groupedCategories.map((group, index) => (
                            <SwiperSlide>
                                {group.map((category, key) => (
                                    <div
                                        onClick={() => window.location.href = `/tienda/${sanitizeUrl(category.name)}?uid=${category.uid}&categoryName=${category.name}`}
                                        key={`category-${key}`} 
                                        className="card-categories">
                                        <div className="card-categories__header">
                                            <img src={category?.image ? process.env.REACT_APP_API_BASE_URL + '/uploads/categories/' + category.image : ""} alt="category" />
                                        </div>
                                        <div className="card-categories__title">
                                            <h3>{category.name}</h3>
                                        </div>
                                    </div>
                                ))}
                            </SwiperSlide>
                        ))
                    )}

                    {/* <SwiperSlide key={`group-`}>
                        <div
                            onClick={() => window.location.href = `/tienda`}
                            key={"category-"} 
                            className="card-categories">
                            <div className="card-categories__header">
                                <img src={process.env.REACT_APP_API_BASE_URL + '/uploads/categories/cat-2-12f3b1276944863c7d98e5711dd6946c8e64d34a.png'} alt="category" />
                            </div>
                            <div className="card-categories__title">
                                <h3>hola</h3>
                            </div>
                        </div>
                        <div
                            onClick={() => window.location.href = `/tienda`}
                            key={"category-"} 
                            className="card-categories">
                            <div className="card-categories__header">
                                <img src={process.env.REACT_APP_API_BASE_URL + '/uploads/categories/cat-2-12f3b1276944863c7d98e5711dd6946c8e64d34a.png'} alt="category" />
                            </div>
                            <div className="card-categories__title">
                                <h3>hola</h3>
                            </div>
                        </div>
                    </SwiperSlide> */}
                </Swiper>
            </div>
        </div>
    );
}

export default HomeCategories;